import React from 'react';

import * as Sentry from '@sentry/nextjs';
import { FallBackUI } from './fallback';

interface State {
  error: string | null;
}

interface IErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export class ErrorBoundary extends React.Component<IErrorBoundaryProps, State> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: { message: string }) {
    return {
      error: error.message,
    };
  }

  static componentDidCatch(error: Error, errorInfo: { [x: string]: unknown }) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });

      Sentry.captureException(error);
    });
  }

  render() {
    const { error } = this.state;
    const { children, fallback } = this.props;

    if (error) {
      return fallback ? fallback : <FallBackUI />;
    }
    return children;
  }
}
